export default __webpack_public_path__ + "static/media/AGN_logo_def2.6e8c171f.svg";